import {Component} from '@angular/core';
import {EventService} from "../../../service/api/event.service";
import {CreateEventRequest} from "../../../shared/model/request/create-event-request.model";
import {EventResponse} from "../../../shared/model/response/event/event-response.model";
import {Router} from "@angular/router";
import {take} from "rxjs";
import {ApiResponse} from "../../../shared/model/response/ApiResponse";
import {FilePondFile} from "filepond";
import {MessageToastService} from "../../../service/message-toast.service";

@Component({
    selector: 'app-createevent',
    templateUrl: './createevent.component.html',
    standalone: false
})
export class CreateeventComponent {


  category: string

  apiErrors: Map<string, string> = new Map<string, string>()

  constructor(private eventService: EventService,
              private toastMessage: MessageToastService,
              private router: Router,
  ) {
  }

  submitForm($event: { data: CreateEventRequest; image: FilePondFile; original?: File; redacted?: File }) {
    this.eventService.saveEvent($event.data, $event.image, $event.original, $event.redacted).pipe(take(1))
      .subscribe({
        next: (response: ApiResponse<EventResponse>) => {
          this.router.navigate(["/ocorrencia/" + response?.data?.slug]).then();
        },
        error: (err: ApiResponse<any>) => {
          this.apiErrors = err?.formErrors ?? new Map()
          this.toastMessage.error(err?.message)
        }
      })
  }
}
